import { WarningOutlined } from '@ant-design/icons';
import { frequencies } from '@features/SendoutCreationModal/components/SendMessageModal/data/frequency';
import { Button, Checkbox, Form, Select, Typography } from 'antd';

import { TagSelect } from '@app/components';
import { MessageInputWithFilesUpload } from '@app/components/MessageInputWithFilesUpload';
import { Schedule } from '@app/components/Schedule';

import {
  useEditSendouts,
  useEditSendoutsEffects,
} from '@pages/Sendouts/EditSendouts/hooks';
import type { EditSendoutsForm } from '@pages/Sendouts/EditSendouts/types';

import '@pages/Sendouts/EditSendouts/styles/EditSendouts.desktop.scss';

const PF = 'edit-sendouts';
const { Item } = Form;
const { Text } = Typography;

export const EditSendouts = () => {
  const {
    form,
    onFinish,
    initForm,
    isPageLoading,
    showSchedule,
    initTimezones,
    timezones,
    tagOptions,
    onCancel,
  } = useEditSendouts();

  useEditSendoutsEffects({ initForm, initTimezones });

  return (
    <Form<EditSendoutsForm>
      form={form}
      onFinish={onFinish}
      disabled={isPageLoading}
      className={`${PF}__form`}
    >
      <MessageInputWithFilesUpload
        formInstance={form}
        messageFieldFormItemName="Message"
        onChange={({ target: { value } }) => {
          form.setFieldsValue({ Message: value });
        }}
      />

      <Text>Присвоить тег после отправки:1</Text>
      <Item name="TagIds">
        <TagSelect
          className={`${PF}_fields_select`}
          placeholder="Выберите теги"
          dataTestId="tag-select"
          tagTestId="name-selected-tag"
          size="large"
          showSearch
          disabled={isPageLoading}
          options={tagOptions}
          onChange={(selectedTags) => {
            form.setFieldsValue({ TagIds: selectedTags });
          }}
        />
      </Item>

      <Item label="Периодичность" colon name="SendoutDelaySec">
        <Select className="full-width" options={frequencies} />
      </Item>

      <Item>
        <Text strong type="danger">
          <WarningOutlined /> Внимание! {'  '}
        </Text>
        <Text type="danger">
          Если аккаунт интеграции новый, рекомендуем увеличить периодичность
          отправляемых сообщений
        </Text>
      </Item>

      <Item name="IsSchedule" valuePropName="checked">
        <Checkbox>Отправлять сообщения по графику</Checkbox>
      </Item>

      {showSchedule && (
        <>
          <Item>
            <Text strong>График рассылки:</Text>
            <Schedule form={form} />
          </Item>
          <Item
            name="Timezone"
            label="Часовой пояс"
            colon
            wrapperCol={{ offset: 2, span: 32 }}
            required
            rules={[{ required: true, message: 'Выберите часовой пояс' }]}
          >
            <Select
              placeholder="Выберите часовой пояс"
              optionLabelProp="label"
              options={timezones.map(({ Name, Id }) => ({
                label: Name,
                value: Id,
              }))}
            />
          </Item>
        </>
      )}
      <div className={`${PF}__footer`}>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className={`${PF}__footer__button`}
          disabled={isPageLoading}
          data-testid="save"
        >
          Сохранить
        </Button>
        <Button
          type="default"
          size="large"
          className={`${PF}__footer__button`}
          onClick={onCancel}
          disabled={isPageLoading}
          data-testid="cancel"
        >
          Отмена
        </Button>
      </div>
    </Form>
  );
};
